// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navbar_navbar__pYqcz {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background: #ffffff;
  border-bottom: 1px solid #f1f1f1;
  z-index: 1000;
  padding: 12px 60px;
}

.Navbar_container__g6Thm {
  /* max-width: 1280px; */
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 24px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Logo */
.Navbar_logo__pv1Ql {
  font-size: 28px;
  font-weight: 700;
  color: #000;
  cursor: pointer;
}

.Navbar_logo__pv1Ql span {
  color: #644ee5;
}

/* Nav links */
.Navbar_navLinks__SxOlJ {
  display: flex;
  gap: 32px;
}

.Navbar_navLinks__SxOlJ a {
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  transition: color 0.2s ease;
}

.Navbar_navLinks__SxOlJ a:hover {
  color: #000;
}

/* Sign In Button */
.Navbar_signInBtn__E38wJ {
  background: #644ee5;
  background: var(--Violet, #644ee5);
  border-radius: 8px;
  color: #fff;
  color: var(--White, #fff);

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;

  padding: 12px 24px;
  border: none;
  cursor: pointer;

  transition: all 0.3s ease;
}

.Navbar_signInBtn__E38wJ:hover {
  background-color: #4e38b3;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/components/Navbar.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,SAAS;AACT;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,yBAAyB;;EAEzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;EAEjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;;EAEf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,iFAAiF;AACnF","sourcesContent":[".navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 80px;\n  background: #ffffff;\n  border-bottom: 1px solid #f1f1f1;\n  z-index: 1000;\n  padding: 12px 60px;\n}\n\n.container {\n  /* max-width: 1280px; */\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  padding: 0 24px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Logo */\n.logo {\n  font-size: 28px;\n  font-weight: 700;\n  color: #000;\n  cursor: pointer;\n}\n\n.logo span {\n  color: #644ee5;\n}\n\n/* Nav links */\n.navLinks {\n  display: flex;\n  gap: 32px;\n}\n\n.navLinks a {\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  color: #475569;\n  transition: color 0.2s ease;\n}\n\n.navLinks a:hover {\n  color: #000;\n}\n\n/* Sign In Button */\n.signInBtn {\n  background: #644ee5;\n  background: var(--Violet, #644ee5);\n  border-radius: 8px;\n  color: #fff;\n  color: var(--White, #fff);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n\n  padding: 12px 24px;\n  border: none;\n  cursor: pointer;\n\n  transition: all 0.3s ease;\n}\n\n.signInBtn:hover {\n  background-color: #4e38b3;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `Navbar_navbar__pYqcz`,
	"container": `Navbar_container__g6Thm`,
	"logo": `Navbar_logo__pv1Ql`,
	"navLinks": `Navbar_navLinks__SxOlJ`,
	"signInBtn": `Navbar_signInBtn__E38wJ`
};
export default ___CSS_LOADER_EXPORT___;
